export default __webpack_public_path__ + "static/media/ic-checked.e9a80c2b.svg";